<template>
  <div class="connect px">
    <div class="text">{{ text }}</div>
    <div
      class="rotating-circle px"
      :style="isLoading ? 'opacity: 1;' : 'opacity: 0;'"
    ></div>
    <div class="buttons" v-if="!isStart">
      <a class="button" :href="winUrl" download="AMasterDriverSetup.zip">
        <md-button> {{ $t("mouse.startAMMaster") }} (Windows) </md-button>
      </a>
      <a class="button" :href="macUrl" download="AMasterDriverSetup.zip">
        <md-button> {{ $t("mouse.startAMMaster") }} (Mac) </md-button>
      </a>
      <a class="button" @click="refresh">
        <md-button>
          {{ $t("refresh") }}
        </md-button>
      </a>
    </div>
    <div class="buttons" v-if="false">
      <a class="button" href="AMasterDriver://">
        AMasterDriver://
      </a>

      <a class="button" href="AMasterLauncher://">
        AMasterLauncher://
      </a>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { Modal } from "ant-design-vue";
import { download } from "@/utils";

export default {
  data() {
    return {
      text: "",
      num: 0,
      port: 11223,
      isLoading: true,
      isStart: true,
    };
  },
  computed: {
    ...mapState("loader", {
      loading: "loading",
    }),
    ...mapState("app", {
      isTest: "isTest",
    }),
    winUrl() {
      return `https://angrymiao-www.oss-cn-shenzhen.aliyuncs.com/diy/AMasterDriverSetup${
        this.isTest ? "Test" : ""
      }.zip`;
    },
    macUrl() {
      return `https://angrymiao-www.oss-cn-shenzhen.aliyuncs.com/diy/AMasterDriverSetupMac${
        this.isTest ? "Test" : ""
      }.zip`;
    },
  },
  methods: {
    connectWS() {
      console.log("Bridge", "WS");
      console.log("WebSocket connecting");
      this.text = this.$t("mouse.connectAMMaster");
      const isSafari =
        /^((?!chrome|android).)*safari/i.test(navigator.userAgent) &&
        navigator.vendor === "Apple Computer, Inc.";
      const WS = new WebSocket(
        (isSafari ? "wss://127.0.0.1:" : "ws://127.0.0.1:") + this.port
      );

      // 连接成功时触发
      WS.addEventListener("open", (event) => {
        console.log("WebSocket connection opened:", this.port, event);
        this.text = this.$t("mouse.connectMouse");
        WS.send('{"method":"hello","data":"AM  Master"}');
      });

      // 连接关闭时触发
      WS.addEventListener("close", (event) => {
        this.isLoading = false;
        setTimeout(() => (this.isLoading = true), 800);
        if (!window.WS) {
          this.num++;
          if (this.num <= 2) {
            this.isStart = false;
            console.error("AMasterLauncher://");
            setTimeout(() => {
              window.location.href = "AMasterLauncher://";
            }, 1000);
          }
          setTimeout(() => {
            this.text = this.$t("mouse.retryConnectAMMaster");
            this.connectWS();
          }, 1000);
        }
        console.log("WebSocket connection closed:", this.port, event);
      });

      // 发生错误时触发
      WS.addEventListener("error", (event) => {
        this.isLoading = false;
        setTimeout(() => (this.isLoading = true), 800);
        console.error("WebSocket error:", this.port, event);
      });

      // 接收到消息时触发
      WS.addEventListener("message", (event) => {
        console.log("Message from server:", this.port, event.data);
        if (event.data) {
          const res = JSON.parse(event.data);
          if (res.method === "hello") {
            this.isLoading = false;
            setTimeout(() => (this.isLoading = true), 800);
            this.$store.dispatch("mouse/setVersion", {
              version: res.data === "web" ? "1.0.0" : res.data,
              isLatestVersion: res.data === "web" ? false : res.data >= "1.0.2",
            });
            if (res.data === "web") {
              this.$store.dispatch("loader/setLoading", false);
              Modal.destroyAll();
              this.$confirm({
                title: this.$t("loader.forceUpdate", ["AMasterDriver"]),
                okText: this.$t("loader.update"),
                cancelText: this.$t("cancel"),
                centered: true,
                onOk: () => {
                  this.isStart = false;
                  const isMac = navigator.platform
                    .toUpperCase()
                    .includes("MAC");
                  if (isMac) {
                    this.onDownload(this.macUrl, "AMasterDriverSetupMac.zip");
                  } else {
                    this.onDownload(this.winUrl, "AMasterDriverSetup.zip");
                  }
                },
                onCancel: () => {
                  window.WS = WS;
                  // WS.send('{"method":"getSystemInfo","data":""}');
                  WS.send('{"method":"connectMouse","data":""}');
                },
              });
              return;
            }
            window.WS = WS;
            // WS.send('{"method":"getSystemInfo","data":""}');
            WS.send('{"method":"connectMouse","data":""}');
            return;
          }
          // if (res.method == "setSystemInfo") {
          //   const systemInfo = res.data;
          //   if (systemInfo.version < "1.3.1") {
          //     this.$store.dispatch("loader/setLoading", true);
          //     Modal.destroyAll();
          //     this.$info({
          //       title: this.$t("loader.forceUpdate", ["AMasterDriver"]),
          //       okText: this.$t("yes"),
          //       centered: true,
          //       onOk: () => {
          //         this.isStart = false;
          //       },
          //     });
          //     return;
          //   }
          //   WS.send('{"method":"connectMouse","data":""}');
          // }
          if (res.method === "connectMouse") {
            if (res.data === "MOUSE") {
              this.isLoading = false;
              this.$router.replace(this.$paths.mouse);
              return;
            }
            if (res.data === "MOUSEDONGLE") {
              this.isLoading = false;
              this.$router.replace(this.$paths.dongleMouse);
              return;
            }
            if (this.loading) return;
            if (this.$route.path.includes(this.$paths.mouseConnect)) {
              this.$message.info(this.$t("mouse.offline"));
            } else {
              this.$store.dispatch("loader/setLoading", true);
              this.$info({
                title: this.$t("mouse.offline"),
                okText: this.$t("yes"),
                centered: true,
                onOk: () => {
                  this.$store.dispatch("loader/setLoading", false);
                  window.location.href = this.$paths.mouseConnect;
                },
              });
              return;
            }
            WS.send('{"method":"connectMouse","data":""}');
            return;
          }
          if (res.method === "updateElectricity") {
            if (res.data.mouseOnline == 0) {
              if (this.loading) return;
              window.updateElectricityTimer = setTimeout(() => {
                this.$store.dispatch("loader/setLoading", true);
                Modal.destroyAll();
                this.$info({
                  title: this.$t("mouse.offline"),
                  okText: this.$t("yes"),
                  centered: true,
                  onOk: () => {
                    this.$store.dispatch("loader/setLoading", false);
                    window.location.href = this.$paths.mouseConnect;
                  },
                });
              }, 1000 * 30);
              return;
            }
          }
          if (window.updateElectricityTimer) {
            clearTimeout(window.updateElectricityTimer);
            Modal.destroyAll();
          }
          // if (window[res.method]) {
          window[res.method](JSON.stringify(res.data));
          // }
        }
      });
    },
    initBridge() {
      const bridge = {};
      const bridgeMethods = [
        "getSystemInfo",
        "initMouseData",
        "getElectricity",
        "resetMouse",
        "changeMouseKey",
        "getMouseDPI",
        "setMouseDPI",
        "getMouseInfo",
        "setMouseProfile",
        "setMouseSnedorAngle",
        "setMouseInfo",
        "getMouseMacro",
        "saveMouseMacro",
        "deleteMouseMacro",
        "setMouseMacro",
        "resetMagnetKey",
        "getMouseSet",
        "autoMouseUpdate",
        "localMouseUpdate",
        "getCurrentVer",
        "clearBlue",
        "loadMousejson",
        "saveMousejson",
        "getMDLight",
        "setMDLight",
        "setDPIButton",
        "setFPS",
        "getDPIButton",
        "getFPS"
      ];
      bridgeMethods.map((method) => {
        bridge[method] = (json) => {
          if (window.WS) {
            const message = JSON.stringify({ method, data: json });
            console.log("WS.send", message);
            if (window.updateElectricityTimer)
              clearTimeout(window.updateElectricityTimer);
            if (
              ![
                "autoMouseUpdate",
                "localMouseUpdate",
                "loadMousejson",
                "saveMousejson",
              ].includes(method)
            ) {
              window.updateElectricityTimer = setTimeout(() => {
                this.$store.dispatch("loader/setLoading", true);
                Modal.destroyAll();
                this.$info({
                  title: this.$t("mouse.offline"),
                  okText: this.$t("yes"),
                  centered: true,
                  onOk: () => {
                    this.$store.dispatch("loader/setLoading", false);
                    window.location.href = this.$paths.mouseConnect;
                  },
                });
              }, 1000 * 30);
            }
            window.WS.send(message);
          } else if (!window.location.href.includes("localhost")) {
            this.$router.replace(this.$paths.mouseConnect);
          }
        };
      });
      this.$store.dispatch("loader/setBridge", bridge);
    },
    onDownload(file, fileName) {
      download(file, fileName);
      this.$store.dispatch("loader/setLoading", {
        loading: true,
        time: 60000,
      });
    },
    refresh() {
      window.location.reload();
    },
  },
  mounted() {
    const isChromeOrEdge =
      (/(Chrome\/\d+\.\d+\.\d+\.\d+|Edg\/\d+\.\d+\.\d+\.\d+)/.test(
        navigator.userAgent
      ) &&
        navigator.vendor === "Google Inc.") ||
      /Edg/.test(navigator.userAgent);
    if (isChromeOrEdge || true) {
      this.initBridge();
      if (window.location.href.includes("localhost")) {
        this.$router.replace(this.$paths.mouse);
        return;
      }
      this.$store.dispatch("loader/setInLoader", true);
      this.connectWS();
    } else {
      this.text = this.$t("mouse.browser");
    }
  },
};
</script>
<style lang="scss" scoped>
.connect {
  width: 100%;
  height: 100vh;
  font-size: 16px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .logo {
    width: 500px;
    height: auto;
    margin-bottom: 150px;
  }

  .text {
    width: 800px;
    font-size: 76px;
    font-weight: 600;
    text-align: center;
    letter-spacing: 0;
    margin-bottom: 60px;
    margin-top: -30px;
    color: transparent;
    background: linear-gradient(270deg, #8743ff 0%, #4136f1 50%, #8743ff 100%);
    background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: scroll 1.5s linear infinite;
    display: inline;
  }

  .rotating-circle.px {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    position: relative;
    animation: rotate 2s linear infinite;
    transition: opacity 0.5s ease-in-out;
    background: conic-gradient(from 0deg, #8743ff, #4136f1, #8743ff);
    margin-bottom: 60px;
    padding: 10px;
  }

  .rotating-circle.px::before {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: #171717;
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(360deg);
    }
    100% {
      transform: rotate(720deg);
    }
  }

  .buttons {
    @include flex-center;

    .button {
      background-color: $primary-color;
      border-radius: 5px;
      font-size: 24px;
      text-transform: none;
      margin-right: 30px;

      &:last-child {
        margin-right: 0;
      }
    }
  }
}

@keyframes scroll {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 800px 0;
  }
}
</style>
